import React, { useState } from 'react';

import type { DrawReactComponentProps } from '@aline/common';
import { useReactiveVar } from '@apollo/client/react';
import { EditorPopover } from 'src/components';
import { SignatureFieldPopoverContent } from 'src/editor/popovers';
import { Queries } from 'src/editor/queries';
import { IS_MOBILE } from 'src/helpers/environment';

import { resizingSignatureFieldIdVar } from './SignatureFieldPlaceholder';

export function SignatureFieldPopoverAnchor({
  signatureFieldEntry,
}: DrawReactComponentProps['SignatureFieldPopoverAnchor']) {
  const [reference, setReference] = useState<HTMLDivElement | null>(null);
  const [rMSignatureField] = signatureFieldEntry;
  const { imgHeightPx: height, imgWidthPx: width } =
    Queries.getSignatureImageDimensions(rMSignatureField);
  const resizingFieldId = useReactiveVar(resizingSignatureFieldIdVar);
  const isResizing = resizingFieldId === rMSignatureField.fieldId;

  return (
    <>
      <div ref={setReference} style={{ height, pointerEvents: 'none', width }} />

      {!IS_MOBILE && !isResizing && (
        <EditorPopover placement="bottom" reference={reference}>
          <SignatureFieldPopoverContent signatureFieldEntry={signatureFieldEntry} />
        </EditorPopover>
      )}
    </>
  );
}
